import { MainContentContainer } from "@app/components/MainContainer";
import { MainHeader } from "@app/components/MainContainer/MainHeader";
import { MainContent } from "@app/components/MainContainer/MainContent";
import { MainTitle } from "@app/components/MainContainer/MainTitle";
import { MainDescription } from "@app/components/MainContainer/MainDescription";
import {
  GroupAddModal,
} from "@app/components/modals/GroupModal";
import {PostingGroupTable} from "src/components/table/PostingGroupTable"
import { Button, useModal, Switch } from "@shortsworks/ui";
import {
  useGetStoryGroupList,
} from "@shortsworks/user-api";
import { useQueryClient } from "@tanstack/react-query";
import {LoaderCircle, ShareIcon, CopyIcon, EditIcon, TrashIcon} from "lucide-react"

const methodsOfGroupList = [];

export const PostingGroups = () => {
  const { showModal } = useModal();

  const queryClient = useQueryClient();
  const {
    data: storyGroupListData,
    queryKey: storyGroupListQueryKey,
    isSuccess: isSuccessGetStoryGroupList,
  } = useGetStoryGroupList();


  if (!isSuccessGetStoryGroupList) {
    return (
      <div className="flex w-full h-full items-center justify-center">
        <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
      </div>
    );
  }

  const groups = storyGroupListData.data;
  const handleAddGroup = () => {
    return showModal(GroupAddModal);
  };


  return (
    <MainContentContainer>
      <MainHeader>
        <MainTitle>포스팅 그룹 목록</MainTitle>
        <MainDescription>그룹 목록을 확인할 수 있습니다.</MainDescription>
      </MainHeader>
      <MainContent>
        <PostingGroupTable data={groups ?? []}/>
        <Button className="mt-4" onClick={handleAddGroup}>그룹 추가</Button>
      </MainContent>
    </MainContentContainer>
  );
};
